import gql from 'graphql-tag';
import Client from "../services/Client";
import Cookie from "../services/Cookie";


const UserAction = {

    /**
     * @purpose: get user survay
     * @author: Arijit Deb Roy
     * @return: userId: int, courseId: int
     */
    userSurvey(userId, courseId) {
        const COURSEWISE_SURVEY_DETAILS = gql`query fetchCourseWiseUserSurveyDetails($token: AccessToken!,$input: CourseWiseUserSurveyDetailsInput!){
            fetchCourseWiseUserSurveyDetails(token: $token , input: $input){
              code
              status
              message
              data{
                selectedCourseId
                courseData{
                  userSurveyId
                  userId
                  userHashIddialCode
                  courseId
                  courseName
                  examDate
                  status
                  createdBy
                  createdAt
                  updatedAt
                }
              }
            }
           }`;
        return Client.query({
            query: COURSEWISE_SURVEY_DETAILS,
            variables: {
                input: {
                    userId: userId,
                    courseId: courseId,
                    excludeCourseIds: process.env.NEXT_PUBLIC_EXCLUDE_COURSE_IDS.split(',')
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: modify user survay with token
     * @author: Arijit Deb Roy
     * @return: userId: int, courseId: int, examDate: string
     */
    modifyUserSurvey(userId, courseId, examDate) {
        const MODIFY_USER_SURVEY = gql`mutation modifyUserSurvey($token:AccessToken!,$input: UserSurveyModifyInputPayload!) {
              modifyUserSurvey(token:$token,input: $input) {
                code
                status
                message
              }
            }`
        return Client.mutate({
            mutation: MODIFY_USER_SURVEY,
            variables: {
                input: {
                    userId: userId,
                    courseId: courseId,
                    examDate: examDate
                },
                token: {
                    accessToken: Cookie.getCookie('_token'),
                }
            }
        });
    },

    /**
     * @purpose: get user details
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    detailUser(userId) {
        const DETAIL_USER = gql`
                    query detailUser($token: AccessToken!, $input: UserDetailsInput!){
                      detailUser(token: $token, input: $input){
                        code
                        status
                        message
                        data{
                          totalCount
                          user{
                            userId
                            firstName
                            lastName
                            dialCode
                            email
                            mobile
                            lastLogin
                            otherDetails
                            userStatus
                            orgId
                            roleDetails
                            orgName
                            countryId
                            countryName
                            countryCode
                            roles
                            fileId
                            filePath
                            schoolName
                            schoolBoard
                            gender
                            grade
                            userDisability
                            disabilityStatus
                          }
                        }
                      }
                    }
                `;
        return Client.query({
            query: DETAIL_USER,
            variables: {
                input: {
                    userId: userId,
                },
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },

    /**
     * @purpose: update user details
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    updateUserDetails(inputObj) {
        const MODIFY_USER_DETAILS = gql`
          mutation updateUserDetails($token: AccessToken!, $input: UserBasicDetailModifyInput!) {
            updateUserDetails(token: $token, input: $input) {
              code
              status
              message
            }
          }
        `;
        return Client.mutate({
            mutation: MODIFY_USER_DETAILS,
            variables: {
                input: inputObj,
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },

    /**
     * @purpose: update user previous exam score
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    modifyPreviousExamScore(previousUserExam) {
        const MODIFY_EXAM_SCORE = gql`
        mutation modifyPreviousExamScore($token: AccessToken!, $input: ModifyPreviousExamScoreInput!) {
        modifyPreviousExamScore(token: $token, input: $input) {
            code
            status
            message
        }
        }
        `;
        return Client.mutate({
            mutation: MODIFY_EXAM_SCORE,
            variables: {
                input: previousUserExam,
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },
    
    /**
     * @purpose: parent invitation
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    inviteParent(inputObj) {
        const INVITE_PARENT = gql`
            mutation inviteParent($token: AccessToken!, $input: InviteParentInput!){
            inviteParent(token:$token,input:$input){
                code
                status
                message
            }
            }
        `;
        return Client.mutate({
            mutation: INVITE_PARENT,
            variables: {
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                },
                input: {
                    userId: inputObj.userId,
                    token: inputObj.token
                }
            }
        });
    },


    /**
     * @purpose: get all subscriptions for user
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    Subscriptions(userId) {
        const Email_Subscription = gql`
        query getSubscription($input: EmailSubscriptionListInput!, $token: AccessToken!) {
            getSubscription(input: $input, token: $token) {
            status
            code
            message
            data {
                subscriptionList {
                userId
                type
                status
                }
                totalCount
            }
            }
        }
        `;
        return Client.query({
            query: Email_Subscription,
            variables: {
                input: {
                    userId: userId,
                },
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                }
            }
        });
    },

    /**
     * @purpose: update subscriptions for user
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    updateSubscriptions(subscriptionList) {
        const Manage_Subscription = gql`
        mutation manageSubscription($input: EmailSubscriptionManageInput!, $token: AccessToken!) {
            manageSubscription(input: $input, token: $token) {
            status
            code
            message
            data
            }
        }
        `;
        return Client.mutate({
            mutation: Manage_Subscription,
            variables: {
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                },
                input: {
                    userId: subscriptionList.userId,
                    type: subscriptionList.type,
                    status: subscriptionList.status
                }
             
          
            }
        });
    },
    
    /**
     * @purpose: check if a user is anonymous or not
     * @author: Arijit Deb Roy
     * @return: <JSON>
     */
    anonymousCheckUser(inputObj) {
        const CHECK_USER = gql`
            query anonymousCheckUser($input: anonymousCheckUserInput!) {
            anonymousCheckUser(input: $input) {
                code
                status
                message {
                status
                }
            }
            }
        `;
        return Client.query({
            query: CHECK_USER,
            variables: {
                input: {
                    email: inputObj.email
                }
            }
        });
    },

    /**
     * user detail response without token
     * @author: Susanta Chakraborty
     * @params: userId: <Integer>
     */
    unauthDetailUser(userId=0) {
        const DETAIL_USER_UNAUTH = gql`
                query unauthDetailUser($input: UserDetailsInput!) {
                    unauthDetailUser(input:$input){
                    code
                    status
                    message
                    data {
                        user {
                            userId
                            userStatus
                            userDisability
                            disabilityStatus
                            firstName
                            lastName
                            email
                            dialCode
                            filePath
                            lastIp
                            mobile
                            lastLogin
                            otherDetails
                            orgId
                            orgName
                            orgHeadId
                            gender
                            countryId
                            countryName
                            countryCode
                            schoolName
                            schoolBoard
                            createdAt
                            createdBy
                            grade
                            }
                        totalCount
                        }
                    }
                }
            `;
        return Client.query({
            query: DETAIL_USER_UNAUTH,
            variables: {
                input: {
                    userId: userId,
                }
            }
        });
    },
    /**
     * user avatar list response without token
     * @author: Susanta Chakraborty
     * @params: void
     */
    userAvatarList() {
        const AVATAR_LIST = gql`
                query userAvatarList {
                    userAvartarList {
                        code
                        status
                        message
                        data {
                        avatars {
                            fileId
                            fileName
                            filePath
                            fileType
                            fileStatus
                            contentType
                        }
                        totalCount
                        }
                    }
                }`;
        return Client.query({
            query: AVATAR_LIST
        });
    },

    /**
     * List of parents by student ID
     * @author: Susanta Chakraborty
     * @params: inputObj: <Object> {userId: <Integer> status: <bool>, offset: <int>, limit: <int>}
     */
    parentList(userId) {
        const PARENT_LIST = gql`
          query fetchParentListByStudentId($token: AccessToken!, $input: StudentParentListInput!){
            fetchParentListByStudentId(token: $token , input: $input){
              code
              status
              message
              data{
                totalCount
                parentList{
                  userId
                  firstName
                  lastName
                  email
                  mobile
                  filePath
                }
              }
            }
          }
        `;
        return Client.query({
            query: PARENT_LIST,
            variables: {
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                },
                input: {
                    filters: {
                        userId: userId
                    },
                    pagination: {
                        status: false,
                        limit: 10,
                        offset: 0
                    }
                }
            }
        });
    },
    /**
     * List of teachers by student ID
     * @author: Susanta Chakraborty
     * @params: inputObj: <Object> {userId: <Integer>, courseId: <Integer>, status: <bool>, offset: <int>, limit: <int>}
     */
    teacherList(userId, courseId) {
        const TEACHER_LIST = gql`
          query fetchTeacherListByStudentId($token: AccessToken!, $input: StudentTeacherListInput!){
            fetchTeacherListByStudentId(token: $token , input: $input){
              code
              status
              message
              data{
                totalCount
                teacherList{
                  userId
                  firstName
                  lastName
                  email
                  courseName
                  courseId
                  studentCount
                  status
                  filePath
                  mobile
                }
              }
            }
          }
        `;
        return Client.query({
            query: TEACHER_LIST,
            variables: {
                token: {
                    accessToken : Cookie.getCookie('_token'),
                    accessRole : 6
                },
                input: {
                    filters: {
                        userId: userId,
                        courseId: courseId,
                    },
                    pagination: {
                        status: false,
                        limit: 10,
                        offset: 0
                    }
                }
            }
        });
    },

    /**
     * agent details by referral code or user id
     * @author: Arijit Deb Roy
     * @params: userId: <Integer>, referralCode: <String>
     */
    agentDetails(input) {
        const AGENT_DETAILS = gql`
        query agentDetails($input: AgentDetailsInput!) {
            agentDetails(input: $input) {
              code
              status
              message
              data {
                firstName
                lastName
                email
                phone
                referenceCode
                userStatus
                agentStatus
              }
            }
          }          
        `;
        return Client.query({
            query: AGENT_DETAILS,
            variables: {
                input: input,
            }
        });
    },

}

export default UserAction;
